function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#56b7e9",
  d: "m10.05 50.05c0 10.15 3.674 19.44 9.764 26.62l-6.355 7.106c-8.332-8.89-13.42-20.73-13.42-33.73 0-27.59 22.9-49.95 51.16-49.95s51.16 22.36 51.16 49.95c0 13-5.084 24.84-13.42 33.72l-6.355-7.106c6.09-7.176 9.764-16.46 9.764-26.62 0-22.73-18.42-41.15-41.15-41.15s-41.15 18.42-41.15 41.15"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#002b55",
  d: "m46.72 33.56c0 2.474 2.007 4.48 4.481 4.48s4.481-2.006 4.481-4.48c0-2.478-2.007-4.484-4.481-4.484s-4.481 2.006-4.481 4.484zm-8.529 11.21h7.993v-0.9829c-3.902-1.827-6.596-5.721-6.596-10.23 0-6.263 5.199-11.34 11.61-11.34 6.412 0 11.61 5.076 11.61 11.34 0 4.505-2.693 8.399-6.595 10.23v0.9829h7.993v6.117h-7.993v40.01c7.848-0.9538 15.01-4.118 20.86-8.849l6.038 7.042c-8.748 6.827-19.84 10.91-31.91 10.91s-23.16-4.079-31.91-10.91l6.039-7.042c5.845 4.731 13.01 7.895 20.86 8.849v-40.01h-7.993v-6.117"
});

function SvgKnAnchor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.5 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnAnchor);
export default __webpack_public_path__ + "static/media/kn_anchor.a3869dc7.svg";
export { ForwardRef as ReactComponent };